import script from "./ProjectAbout.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectAbout.vue?vue&type=script&setup=true&lang=js"

import "./ProjectAbout.vue?vue&type=style&index=0&id=58cb72e8&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58cb72e8"]])

export default __exports__